<template>
    <div>
        <div class="pagetitle">
            <h1>Technology</h1>
            <nav>
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">Home</li>
                    <li class="breadcrumb-item">Forms</li>
                    <li class="breadcrumb-item active">Technology</li>
                </ol>
            </nav>
        </div>
        <div class="col text-left">
            <a href="#" class="btn btn-sm btn-primary shadow-sm" data-toggle="modal" data-target="#tambahTechnology">
                <i class="bi bi-plus fa-sm text-white-50"></i> Tambah Technology
            </a>
        </div>
        <br>
        <div class="row mb-3">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <h5 class="card-title">Technology</h5>
                        <div>
                            <label for="searchQuery" class="form-label">Search:</label>
                            <input type="text" class="form-control" id="searchQuery" v-model="searchQuery" @change="fetchTechnology" placeholder="Search..."/>
                            <div class="form-group mb-3">
                                <label for="pageSize" class="form-label">Items per page:</label>
                                <select name="pageSize" v-model="pageSize" @change="fetchTechnology" class="form-select" id="pageSize">
                                    <option v-for="size in sizes" :key="size" :value="size">
                                        {{ size }}
                                    </option>
                                </select>
                            </div>
                            <table class="table table-striped table-hover">
                                <thead class="thead-dark">
                                    <tr>
                                        <th scope="col">No</th>
                                        <th scope="col">Judul</th>
                                        <th scope="col">Keterangan</th>
                                        <th scope="col">Icon</th>
                                        <th scope="col">Bahasa</th>
                                        <th scope="col">Status</th>
                                        <th scope="col" style="text-align: center;">Opsi</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(technology, index) in filteredTechnologies" :key="index">
                                        <td>{{ index + 1 + (currentPage - 1) * pageSize }}</td>
                                        <td>{{ technology.name }}</td>
                                        <td>{{ technology.deskripsi }}</td>
                                        <td><i :class="technology.icon"></i></td>
                                        <td>{{ technology.language == 'id' ? '🇮🇩 Indonesia' : '🇬🇧 English' }}</td>
                                        <td>
                                            <span v-if="technology.status == '1'" class="badge bg-success">Active</span>
                                            <span v-else class="badge bg-danger">Inactive</span>
                                        </td>
                                        <td style="text-align:center">
                                            <a href="#" class="btn btn-sm btn-outline-primary shadow-sm" style="margin-right: 5px" @click="showModal('detail', technology.id)">
                                                <i class="bi bi-eye fa-sm text-dark"></i>
                                            </a>
                                            <a href="#" class="btn btn-sm btn-outline-danger shadow-sm" style="margin-right: 5px" @click="deleteTechnology(technology.id)">
                                                <i class="bi bi-trash fa-sm text-dark"></i>
                                            </a>
                                            <a href="#" class="btn btn-sm btn-outline-warning shadow-sm" style="margin-right: 5px" @click="showModal('edit', technology.id)">
                                                <i class="bi bi-pencil-square fa-sm text-dark"></i>
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <nav aria-label="Page navigation">
                                <ul class="pagination justify-content-center" @change="fetchTechnology">
                                    <li class="page-item" :class="{ disabled: currentPage === 1}">
                                        <button class="page-link" @click ="changePage(currentPage - 1)" :disabled="currentPage === 1">Previous</button>
                                    </li>
                                    <li v-if="showStartEllipsis" class="page-item disabled">
                                        <span class="page-link">...</span>
                                    </li>
                                    <li
                                        class="page-item"
                                        v-for="page in displayedPages"
                                        :key="page"
                                        :class="{ active: currentPage === page }"
                                    >
                                        <button class="page-link" @click="changePage(page)">{{ page }}</button>
                                    </li>
                                    <li v-if="showEndEllipsis" class="page-item disabled">
                                        <span class="page-link">...</span>
                                    </li>
                                    <li class="page-item" :class="{ disabled: currentPage === pages }">
                                        <button class="page-link" @click="changePage(currentPage + 1)" :disabled="currentPage === pages">Next</button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="tambahTechnology" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="tambahSuratModalLabel">Technology Forms</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form class="row g-3" @submit.prevent="addTechnology">
                            <div class="col-md-12">
                                <div class="form-floating">
                                    <input type="hidden" class="form-control" id="ID" placeholder="ID" v-model="technology.created_by" readonly>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-floating">
                                    <input type="hidden" class="form-control" id="nama" placeholder="nama" v-model="technology.created_by_name" readonly>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-floating">
                                    <input type="text" class="form-control" id="floatingName" placeholder="Title" v-model="technology.name">
                                    <label for="floatingName">Title</label>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-floating">
                                    <textarea class="form-control" placeholder="Deskripsi" id="floatingTextarea" v-model="technology.deskripsi" style="height: 150px;"></textarea>
                                    <label for="floatingTextarea">Deskripsi</label>
                                </div>
                            </div>
                            <div class="col-md-12 mb-3">
                                <div class="form-floating">
                                    <select class="form-select" name="language" id="status" v-model="technology.language">
                                        <option value="id">🇮🇩 Indonesia</option>
                                        <option value="en">🇬🇧 English</option>
                                    </select>
                                    <label for="language">Bahasa</label>
                                </div>
                            </div>
                           <div class="col-md-12" style="position: relative; overflow: visible;">
                                <label class="form-label">Pilih Icon</label>
                                <div class="form-control d-flex align-items-center justify-content-between" @click="dropdownOpen = !dropdownOpen">
                                    <span v-if="technology.icon"><i :class="technology.icon"></i> {{ technology.icon }}</span>
                                    <span v-else class="text-muted">Pilih icon...</span>
                                    <i class="ms-2 bi bi-caret-down-fill"></i>
                                </div>
                                <div v-show="dropdownOpen"
                                    class="border mt-1 p-2 rounded bg-white position-absolute w-100"
                                    style="max-height: 200px; overflow-y: auto; z-index: 1050; max-width: 420px;">
                                    <input
                                        type="text"
                                        class="form-control mb-2"
                                        placeholder="Cari icon..."
                                        v-model="iconSearch"
                                        @input="searchIcon"
                                    />
                                    <div
                                        v-for="icon in icons"
                                        :key="icon"
                                        class="dropdown-item d-flex align-items-center gap-2 py-1"
                                        @click="selectIcon(icon)"
                                        style="cursor: pointer;"
                                    >
                                        <i :class="icon"></i> {{ icon }}
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12 mb-3">
                                <div class="form-floating">
                                    <select class="form-select" name="status" id="status" v-model="technology.status">
                                        <option value="1">Active</option>
                                        <option value="0">Inactive</option>
                                    </select>
                                    <label for="status">Status</label>
                                </div>
                            </div>
                            <div class="text-center">
                                <button type="submit" class="btn btn-primary">Submit</button> ||
                                <button type="button" class="btn btn-secondary" @click="resetForm">Reset</button>
                            </div>
                        </form><!-- End floating Labels Form -->
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal Detail  -->
        <div ref="detailTechnologyModal" class="modal fade" id="detailTechnology" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="detailTechnologyModal">Detail Technology</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="title">Title</label>
                                        <input type="text" class="form-control" id="title" placeholder="Title" v-model="technology.name" readonly>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="floatingTextarea">Deksripsi</label>
                                        <textarea class="form-control" placeholder="Deskripsi" id="floatingTextarea" v-model="technology.deskripsi" style="height: 150px;" disabled></textarea>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="floatingName">Icon</label>
                                        <input type="text" class="form-control" id="floatingName" placeholder="Icon" v-model="technology.icon" readonly>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="pembuat_nama">Nama Pembuat</label>
                                        <input type="text" class="form-control" id="pembuat_nama" placeholder="Nama Pembuat" v-model="technology.created_by_name" readonly>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="language">Bahasa</label>
                                        <input type="text" class="form-control" id="language" placeholder="Bahasa" :value="technology.language === 'id' ? '🇮🇩 Indonesia' : '🇬🇧 English'" readonly>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="status">Status</label>
                                        <select class="form-control" name="status" id="status" v-model="technology.status" disabled>
                                            <option value="1">Active</option>
                                            <option value="0">Inactive</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="text-center">
                            <button class="btn btn-secondary" @click="closeModal"> Close </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal Edit -->
        <div class="modal fade" id="editTechnology" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="EditTechnologyModal">Edit Technology</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form class="row g-3" @submit.prevent="updateTechnology">
                            <div class="col-md-6">
                                <div class="form-floating">
                                    <input type="hidden" class="form-control" id="updated_by" placeholder="ID" v-model="selectedTechnology.updated_by" readonly/>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-floating">
                                    <input type="hidden" class="form-control" id="updated_by_name" placeholder="Nama PEmbuat" v-model="selectedTechnology.updated_by_name" readonly/>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-floating">
                                    <input type="hidden" class="form-control" id="floatingName" placeholder="ID" v-model="technology.id" readonly/>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-floating">
                                    <textarea class="form-control" placeholder="Title" id="floatingTextarea" v-model="technology.name" style="height: 150px;"></textarea>
                                    <label for="floatingTextarea">Title</label>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-floating">
                                    <textarea class="form-control" placeholder="Deskripsi" id="floatingTextarea" v-model="technology.deskripsi" style="height: 150px;"></textarea>
                                    <label for="floatingTextarea">Deskripsi</label>
                                </div>
                            </div>
                            <div class="col-md-12  mb-3">
                                <div class="form-floating">
                                    <select class="form-select" name="language" id="status" v-model="technology.language">
                                        <option value="id">🇮🇩 Indonesia</option>
                                        <option value="en">🇬🇧 English</option>
                                    </select>
                                    <label for="language">Bahasa</label>
                                </div>
                            </div>
                           <div class="col-md-12" style="position: relative; overflow: visible;">
                                <label class="form-label">Pilih Icon</label>
                                <div class="form-control d-flex align-items-center justify-content-between" @click="dropdownOpen = !dropdownOpen">
                                    <span v-if="technology.icon"><i :class="technology.icon"></i> {{ technology.icon }}</span>
                                    <span v-else class="text-muted">Pilih icon...</span>
                                    <i class="ms-2 bi bi-caret-down-fill"></i>
                                </div>
                                <div v-show="dropdownOpen"
                                    class="border mt-1 p-2 rounded bg-white position-absolute w-100"
                                    style="max-height: 200px; overflow-y: auto; z-index: 1050; max-width: 420px;">
                                    <input
                                        type="text"
                                        class="form-control mb-2"
                                        placeholder="Cari icon..."
                                        v-model="iconSearch"
                                        @input="searchIcon"
                                    />
                                    <div
                                        v-for="icon in icons"
                                        :key="icon"
                                        class="dropdown-item d-flex align-items-center gap-2 py-1"
                                        @click="selectIcon(icon)"
                                        style="cursor: pointer;"
                                    >
                                        <i :class="icon"></i> {{ icon }}
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12 mb-3">
                                <div class="form-floating">
                                <select class="form-select" name="status" id="status" v-model="technology.status">
                                    <option value="1">Active</option>
                                    <option value="0">Inactive</option>
                                </select>
                                <label for="is_active">Status</label>
                                </div>
                            </div>
                            <div class="text-center">
                                <button type="submit" class="btn btn-primary">Save</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>  
    </div>
</template>
<script>
import technologyjs from './jsTechnology/technology';
export default technologyjs;
</script>